import React from 'react';

import { useTranslation } from 'react-i18next';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { BlockType, WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { Namespace } from '../../translation/namespace';
import { AppLibraryPersonalBlock } from '../../_blocks/AppLibraryPersonal';
import { InstantBlock } from '../../types/api/Block';

type AppLibraryPersonalFetchProps = InstantBlock<
  { personalAppLibrary: AppLibraryPersonalBlock },
  BlockType.applibraryPersonalFetch
>;

export type AppLibraryPersonalWidget = WidgetShape<[AppLibraryPersonalFetchProps], WidgetType.applibrarypersonal>;

/**
 * App Library Personal Widget to display the icon list in the PAL.
 *
 * - Some quirky mapping from BlockType.applibraryPersonalFetch -> BlockType.applibrarypersonal is needed here
 *  as backend needs to fetch it like this.
 */
export function AppLibraryPersonalWidget({ blocks, uuid, elementType, ...headerProps }: AppLibraryPersonalWidget) {
  const { t } = useTranslation(Namespace.AppLibraryPersonal);

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={elementType}
      uuid={uuid}
      icon={Icons.APP_LIBRARY}
      title={t('widgetTitle')}
    >
      {blocks[0] && <AppLibraryPersonalBlock {...blocks[0].embedded.personalAppLibrary} />}
    </DefaultWidgetWithHeader>
  );
}
